import { Spin, SpinProps } from 'antd';
import { useAppDispatch } from 'app/hooks';
import classNames from 'classnames';
import React, { useEffect } from 'react';

export type RevxSpinProps = SpinProps & { children: React.ReactNode };

export const RevxSpin = (props: RevxSpinProps) => {
  const {
    app: { showLoading, hideLoading },
  } = useAppDispatch();
  useEffect(() => {
    if (props.spinning) {
      showLoading();
    } else {
      hideLoading();
    }
    // eslint-disable-next-line
  }, [props.spinning]);
  return (
    <Spin
      {...props}
      className={classNames('revx-spin', props.className)}
      indicator={<></>}
    >
      {props.children}
    </Spin>
  );
};
